import * as React from 'react';
import { Query } from 'react-apollo';

import { get as getUser } from 'js/lib/user';

import { Box, Button } from '@coursera/coursera-ui';

import PartnerHelpLink from 'bundles/authoring/common/components/PartnerHelpLink';
import withSingleTracked from 'bundles/common/components/withSingleTracked';
import UnlinkConfirmModal from 'bundles/third-party-auth/components/UnlinkConfirmModal';
import withZoomDev from 'bundles/third-party-auth/helpers/withZoomDev';
import { ZoomAuthEmailQuery, getZoomOAuth2Link } from 'bundles/third-party-auth/helpers/zoom';
import { unlink } from 'bundles/third-party-auth/utils/ZoomAuthAPIUtils';

import _t from 'i18n!nls/third-party-auth';

const TrackedButton = withSingleTracked({ type: 'BUTTON' })(Button);

type Props = {
  isDev: boolean;
};

type State = {
  showUnlinkModal: boolean;
};

export class AccountLinkZoom extends React.Component<Props, State> {
  state: State = {
    showUnlinkModal: false,
  };

  refetch = () => {};

  handleDelink = () => {
    const { isDev } = this.props;

    unlink(isDev).then(() => {
      this.refetch();

      this.setState({ showUnlinkModal: false });
    });
  };

  onUnlinkClick = () => {
    this.setState({ showUnlinkModal: true });
  };

  onCancel = () => {
    this.setState({ showUnlinkModal: false });
  };

  render() {
    const { isDev } = this.props;
    const { showUnlinkModal } = this.state;
    const shouldHideLinkZoomSection = !getUser()?.is_staff;

    if (shouldHideLinkZoomSection) {
      return null;
    }

    return (
      <div className="rc-LinkZoom account-link-option">
        {showUnlinkModal && <UnlinkConfirmModal onCancel={this.onCancel} onConfirm={this.handleDelink} />}
        <h3 className="account-link-option__header">{_t('Zoom')}</h3>

        <Query query={ZoomAuthEmailQuery} variables={{ isDev }}>
          {({ data, refetch }: $TSFixMe) => {
            const linkedAccount = data?.ZoomAuthV1Resource?.elements?.[0];

            this.refetch = refetch;

            if (linkedAccount) {
              const showEmail = !!linkedAccount.email;

              return (
                <div>
                  <p>{_t('You can add meetings as live events in your courses.')}</p>

                  <Box flexDirection="column">
                    <span className="label-text">{_t('Linked Zoom Email')}</span>
                    <Box alignItems="center">
                      {showEmail && <span>{linkedAccount.email}</span>}

                      <TrackedButton
                        trackingName="unlink_with_zoom"
                        type="link"
                        onClick={this.onUnlinkClick}
                        label={_t('Unlink')}
                        htmlAttributes={{ 'data-e2e': 'unlink-with-zoom' }}
                      />
                    </Box>
                  </Box>
                </div>
              );
            } else {
              return (
                <div>
                  <p>
                    {_t(
                      `Linking with Zoom will give you the ability to add meetings as live events in your courses.
              You’ll need to be part of a Zoom Pro, Business, or Enterprise account (i.e. one managed by your institution).`
                    )}
                    &nbsp;
                    <PartnerHelpLink articleId="360046759851" />
                  </p>
                  <div className="horizontal-box">
                    <TrackedButton
                      trackingName="link_with_zoom"
                      type="secondary"
                      tag="a"
                      htmlAttributes={{
                        href: getZoomOAuth2Link(isDev),
                        'data-e2e': 'link-with-zoom',
                      }}
                    >
                      {_t('Link with Zoom')}
                    </TrackedButton>
                  </div>
                </div>
              );
            }
          }}
        </Query>
      </div>
    );
  }
}

export default withZoomDev(AccountLinkZoom);
